var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContent)?_c('section',{staticClass:"mt-2"},[_c('div',{staticClass:"bodytext",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }